export default __webpack_public_path__ + "static/media/philippines.cb48f9f6.png";